export const ANONYMOUS = "ANONYMOUS";
export const ADMIN = "ROLE_ONCALL_ADMIN";
export const TECH = "ROLE_ONCALL_TECH";
export const PARTNER_ADMIN = "ROLE_ONCALL_PARTNER_ADMIN";
export const PARTNER_TECH = "ROLE_ONCALL_PARTNER_TECH";

const impersonationRestrictions = {
  [ADMIN]: PARTNER_ADMIN,
  [TECH]: PARTNER_TECH,
};

const impersonatedRole = state =>
  state.impersonatedPartner === null
    ? state.user.role
    : impersonationRestrictions[state.user.role];

export const loggedIn = state => state.user !== null;

export const role = state =>
  loggedIn(state) ? impersonatedRole(state) : ANONYMOUS;

export const username = state => state.user.username;

export const impersonatedPartner = state =>
  state.partners
    ? state.partners.find(partner => partner.id === state.impersonatedPartner)
    : undefined;

export const tokenSelector = state => state.user.token;

export const partnerLogo = state =>
  state.user === null || state.user.logo === "" ? "default" : state.user.logo;



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/selectors/auth.js